module.exports = __webpack_public_path__ + "img/drug_enforcement-gallery-1.9508bece.jpg";